import styled from 'styled-components'
import { maxQuery, minQuery } from '../../../helpers'

export default styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  header {
    margin-bottom: 3em;

    ${maxQuery('md')} {
      margin-bottom: 1.5em;
    }

    .top--row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 10rem;

      h2 {
        color: #fff;
        font-size: 1.5rem;
        font-weight: 600;
        margin: 0;
      }
    }

    .header--row {
      display: flex;
      align-items: center;
      margin-top: 2em;
      justify-content: space-between;

      ${maxQuery('md')} {
        flex-direction: column;
        justify-content: flex-end;
      }

      .search-input {
        padding: 0.75em 1em;
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        color: #fff;
        font-size: 0.95rem;
        min-width: 300px;
        max-width: 40rem;

        ${maxQuery('md')} {
          max-width: 100%;
          width: 100%;
        }

        &::placeholder {
          color: rgba(255, 255, 255, 0.5);
        }

        &:focus {
          outline: none;
          border-color: ${({ theme }) => theme.primary};
        }
      }

      .add--btn {
        display: flex;
        align-items: center;
        gap: 0.5rem;

        ${maxQuery('md')} {
          align-self: flex-end;
          margin-top: 1.5em;
        }

        background: #272B4A;
        border: 0.5px solid rgba(255, 255, 255, 0.08);
        box-sizing: border-box;
        border-radius: 4.02614px;
        color: ${({ theme }) => theme.primary};
        padding: 0.75em 1.5em;
        font-weight: 500;
        font-size: 0.875rem;
        cursor: pointer;
        transition: opacity 0.2s;

        .icon {
          margin-right: 0.2em;
        }

        &:hover {
          opacity: 0.9;
        }
      }
    }
  }

  .content--container {
    background: #272B4A;
    height: 100%;
    border: 0.765294px solid #272B4A;
    box-sizing: border-box;
    border-radius: 8.74621px;
    display: flex;
    flex-direction: column;
    padding: 1.5em 0px;
    overflow: hidden;

    .loading-container {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      p {
        font-size: 1rem;
        margin-top: 1em;
        color: rgba(255, 255, 255, 0.7);
      }
    }

    .riders--grid {
      overflow-y: auto;
      ${minQuery('md')} {
        ${({ theme }) => theme.mixins.scrollbar};
      }
      flex: 1;
      height: 100%;
      display: grid;
      grid-template-columns: repeat(auto-fill, 220px);
      padding: 1em 2em;
      grid-gap: 1.5em;
      align-content: start;

      ${maxQuery('lg')} {
        grid-template-columns: repeat(auto-fill, 200px);
      }
      ${maxQuery('md')} {
        grid-template-columns: repeat(auto-fill, 180px);
        padding: 1em;
        grid-gap: 1em;
      }
      ${maxQuery('sm')} {
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
      }
    }

    .empty--container {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 100%;
      max-width: 80%;
      margin: 0 auto;
      justify-content: center;

      h3 {
        margin: 1.5em 0px;
        color: rgba(255, 255, 255, 0.8);
        font-weight: 400;
        font-size: 1.125rem;
      }

      .instruction {
        background: rgba(36, 26, 26, 0.15);
        border: 0.688406px solid rgba(255, 255, 255, 0.1);
        box-sizing: border-box;
        border-radius: 3.44203px;
        padding: 1em 2em;
        font-size: 0.9rem;
        color: rgba(255, 255, 255, 0.4);
        text-align: center;
        margin-bottom: 2em;

        span {
          color: #fff;
        }
      }

      button.add--btn {
        margin-top: 2.5em;
        display: flex;
        align-items: center;
        background: ${({ theme }) => theme.primary};
        color: #fff;
        border: none;
        padding: 0.75em 1.5em;
        border-radius: 6px;
        font-weight: 500;
        font-size: 0.875rem;
        cursor: pointer;
        transition: opacity 0.2s;

        .icon {
          margin-right: 0.5em;
        }

        &:hover {
          opacity: 0.9;
        }
      }
    }
  }
`
